import React, { useEffect, useState } from "react"
import { ModalPopUp } from "../element/ModalPopUp"
import { MenuAdmin } from "../../admin/MenuAdmin"
import { Header } from "../header/Header"
import { IModalMessage } from "../../../types/error/IModalMessage"
import { useStore } from "../../../stores/RootStoreContext"
import { useNavigate, useParams } from "react-router-dom"
import { IFullCompanyDto } from "../../../types/company/IFullCompanyDto"
import { IFloatingRateDto } from "../../../types/company/IFloatingRateDto"
import * as TrinityAPI from "../../../requests/TrinityAPI"
import { ModalConfirm } from "../element/ModalConfirm"
import { spacedNum } from "../CommonHelper"
import { MenuClient } from "../../client/MenuClient"
import { MenuManager } from "../../manager/MenuManager"
import Button from "@/ui/components/Button"
import { getAdminCompanyViewRoute } from "@/routes"

export const CompanyPage = () => {
  const { userStore } = useStore()
  const params = useParams()
  const [modalMessage, setModalMessage] = useState<IModalMessage | null>(null)
  const [modalConfirm, setModalConfirm] = useState<IModalMessage>()
  const [company, setCompany] = useState<IFullCompanyDto>()
  const [vRates, setVRates] = useState<IFloatingRateDto[]>()
  const [aRates, setARates] = useState<IFloatingRateDto[]>()
  const navigate = useNavigate()

  useEffect(() => {
    if (!params.id) return
    TrinityAPI.getCompany(params.id, response => {
      if (response.status === 200) {
        setCompany(response.data)
      } else {
        setModalMessage({ title: "Ошибка!", text: "Ошибка получения компании: " + response.data.message })
      }
    })
  }, [])

  useEffect(() => {
    if (!company || !company.id || !company.bankId) return
    TrinityAPI.getFloatingRates(company.id, company.bankId, "AMOUNT", response => {
      if (response.status === 200) {
        setARates(response.data)
      } else {
        setModalMessage({ title: "Ошибка!", text: "Ошибка получения данных с сервера: " + response.data.message })
      }
    })
    TrinityAPI.getFloatingRates(company.id, company.bankId, "M_VAL", response => {
      if (response.status === 200) {
        setVRates(response.data)
      } else {
        setModalMessage({ title: "Ошибка!", text: "Ошибка получения данных с сервера: " + response.data.message })
      }
    })
  }, [company])

  const remove = () => {
    if (!params.id) return
    TrinityAPI.removeCompany(params.id, response => {
      if (response.status === 200) {
        navigate(-1)
      } else {
        setModalMessage({ title: "Ошибка!", text: "Ошибка удаления компании: " + response.data.message })
      }
    })
  }

  const confirmRemove = (val: any) => {
    if (val) remove()
  }

  if (company) {
    return (
      <>
        <ModalPopUp message={modalMessage} close={() => setModalMessage(null)} />
        <ModalConfirm message={modalConfirm} setMessage={setModalConfirm} />
        {userStore.isClient ? (
          <MenuClient active={"company"} />
        ) : userStore.isManager ? (
          <MenuManager active={"company"} />
        ) : (
          <MenuAdmin active={"company"} />
        )}
        <main className="main-container">
          <Header />
          <div className="container">
            <h3 className="ui-heading">Компания&nbsp;{company.name}</h3>
            <div className="container-pop-up">
              <div className="form-left-big">
                <div className="form-block-popup">
                  <h4 className="heading-chapter">О компании</h4>
                  <div className="popup-gruop-text">
                    <h3 className="popup-heading">{company.name}</h3>
                    <p className="popup-text">
                      <span className="popup-subline">Юрисдикция:&nbsp;</span>
                      {company.country?.name?.toUpperCase()}
                    </p>
                    <p className="popup-text">
                      <span className="popup-subline">Специализация:&nbsp;</span>
                      {company.okved}
                    </p>
                  </div>
                </div>

                {!userStore.isClient && (
                  <div className="form-block-popup">
                    <h4 className="heading-chapter">Банки и счета</h4>
                    <div className="popup-group-container">
                      {company?.banks &&
                        (company?.banks?.length > 0
                          ? company.banks.map(el => (
                              <div className="popup-gruop-text" key={el.id}>
                                <h3 className="popup-heading">
                                  #{el.id} {el.name?.toUpperCase()}
                                </h3>
                                <div className="grid-3-columns">
                                  <p className="popup-text">
                                    <span className="popup-subline">SWIFT&nbsp;</span>
                                    {el.swift}
                                  </p>
                                  <p className="popup-text">
                                    <span className="popup-subline">Номер счёта&nbsp;</span>
                                    {el.accountNumber}
                                  </p>
                                  <p className="popup-text">
                                    <span className="popup-subline">Валюта счёта&nbsp;</span>
                                    {el.currency}
                                  </p>
                                </div>
                              </div>
                            ))
                          : null)}
                    </div>
                  </div>
                )}
                <div className="form-block-popup">
                  <h4 className="heading-chapter">Страны исключения</h4>
                  <ul className="tag-list">
                    {company.countryExclusions?.map((ce, index) => (
                      <li className="tag-item" key={index}>
                        {ce.name?.toUpperCase()}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>

              {userStore.isClient || userStore.isManager ? (
                <Button variant="grey" onClick={() => navigate(-1)}>
                  Назад
                </Button>
              ) : (
                <div className="flex-row-24">
                  <Button onClick={() => navigate(getAdminCompanyViewRoute(params.id))}>Редактировать</Button>
                  <Button variant="grey" onClick={() => navigate(-1)}>
                    Назад
                  </Button>
                  <Button
                    variant="black"
                    onClick={() =>
                      setModalConfirm({
                        title: "Удалить компанию?",
                        text: `Вы действительно желаете удалить компанию ${company?.name}?`,
                        callbackValue: true,
                        _callback: confirmRemove
                      })
                    }
                  >
                    Удалить компанию
                  </Button>
                </div>
              )}
            </div>
          </div>
        </main>
      </>
    )
  } else {
    return null
  }
}
